import { useContext, useMemo } from "react";
import { StoreContext } from "../../store/context";
import { formatTime } from "../../utils/time";
import InfoBanner from "../InfoBanner";
import { EXPERIAN_DISPLAY_TYPE } from "../../constants/experian";

export const useExperianBanner = () => {
  const { state } = useContext(StoreContext);

  return useMemo(() => {
    if (state.experian?.downtimeFlag && state.experian?.displayType === EXPERIAN_DISPLAY_TYPE.BANNER) {
      const endTime = formatTime({ time: state.experian.endTime });
      return {
        title: `Expect Credit Limit Results After ${endTime}`,
        message: `Our credit partner is temporarily unavailable until ${endTime}. You may continue submitting your application. Results will be communicated to you once the system is restored.`,
      };
    }
    return null;
  }, [state.experian]);
};

const ExperianBanner = () => {
  const experianBanner = useExperianBanner();

  if (!experianBanner) return null;

  const { title, message } = experianBanner;

  return (
    <InfoBanner
      title={title}
      message={message}
      style={{ marginLeft: "-36px", marginRight: "-36px", marginBottom: "16px" }}
    />
  );
};

export default ExperianBanner;
